import * as statics from './statics.min.js';
import * as base from './base.min.js';
import * as mv from './mainVisual.min.js';
import * as hs from './horizontalScroll.min.js';
import * as tm from './topMetaplace.min.js';
import * as md from './modal.min.js';
import * as sa from './scrollAnim.min.js';

// リサイズイベント
export function resizeEvents() {
	let w = $(window).width();
	let wResize;
	let wChange;
	let h_h = $(window).height();
	let h_wi = window.innerHeight;
	let hResize;
	let hResizeAllow = 100;
	let h_hChange;
	let h_wiChange;
	let timer = false;

	// vw, vhのリサイズ（スマホ回転対応、スクロールバーは含まない）
	function calcVh() {
		let vw = $(window).width() * 0.01;
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vw1', vw + 'px');
		document.documentElement.style.setProperty('--vh1', vh + 'px');
	}
	calcVh();

	$(window).on("orientationchange resize", function () {
		if (timer !== false) {
			clearTimeout(timer);
		}

		$('body').addClass('-no-transition');

		timer = setTimeout(function () {
			new Promise(function (resolve) {
				wResize = $(window).width();
				wChange = (w != wResize);
				hResize = window.innerHeight;
				h_hChange = (Math.abs(hResize - h_h) > hResizeAllow);
				h_wiChange = (Math.abs(hResize - h_wi) > hResizeAllow);
				if (wChange || h_hChange || h_wiChange) {
					calcVh();
					w = $(window).width();
					h_h = $(window).height();
					h_wi = window.innerHeight;
				}
				$('body').removeClass('-no-transition');
				resolve();
			}).then(function () {
				timer = setTimeout(function () {
					$(window).trigger("resizeDone");
				}, 100);
			});
		}, 100);
	});

	$(window).on("resizeDone", function () {
		mv.mainVisualTetrahedronsResize();
		tm.metaPlacesShapesResize();
	});
}

$.when(
	base.googleFontLoader(),
	// base.testGrid(),
	base.hideRoadingTransition(),
	base.GenerateKerningSpan(),
	mv.mainVisualPolygons(),
).done(function () {
	base.returnTop();
	md.mainVisualPopupControl();
	tm.metaplacesColorBlocks();
	tm.metaplacesBtn();
	tm.makeWireframeVisual();
	tm.metaplacesLinksControl();
	mv.mainVisualController();
	hs.ScrollController();
	hs.ScrollMouseSlide();
	hs.ScrollCenterCheck();
	sa.intersectionObserverController();
	resizeEvents();
}).fail(function () {
	console.log('JS ERROR');
});